<template>
    <div class='con'>
        <div class="tit-head">
            <div :class="[{'rightT':status == 1},{'errorT':status == -1}]">填空题</div>
            <!-- <div class="stem" v-html="info.title" id="content"></div> -->
            <mavonEditor 
                :class="[{'right':status == 1},{'error':status == -1}]"
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        <div v-if="status">
            <div class="log log_r" v-if="status == 1"><Icon type="md-checkmark" size='26'/></div>
            <div class="log log_e" v-else><Icon type="md-close" size='26'/></div>
        </div>
        <div class="cus-answer" v-if="!isFrom">你输入的答案：<p style="margin-left:20px" v-for="(item,i) in yourAnswer" :key="i">空{{i+1}}： <span style="color:#06c006">{{item}}</span>；</p> </div>
        <div class="right-key">
            <div>正确答案：<p style="margin-left:20px" v-for="(item,i) in correctAnswer" :key="i">空{{i+1}}： <span style="color:#06c006">{{item}}</span>；</p> </div> 
            <span @click="showResolute" v-if="txtSolution || videoSolution">显示解析</span>
        </div>
        <div class="resolve" v-if="showResolutionBox && (txtSolution||videoSolution)" >
            <div class="text" v-if="txtSolution">
                <div style='color:#FF9D00'>文字解析：</div>
                <div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="txtSolution" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </div>
            </div>
            <div class="video" v-if="videoSolution">
                <div>视频解析：</div>
                <video :src="videoSolution" controls style="width:100%"></video>
            </div>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        correctAnswer:{
            type:Array,
            default:null
        },
        yourAnswer:{
            type:Array,
            default:null
        },
        txtSolution:{
            type:String,
            default:null
        },
        videoSolution:{
            type:String,
            default:null
        },
        isFrom:{
            type:Number,
            default:null
        },
        status:{
            type:Number,
            default:null
        }
    },
    data(){
        return{
            showResolutionBox: false,
            answerCount: ''

        }
    },
    mounted(){
        this.answerCount = Number(this.info.answerCount)
        
    },
    methods:{
        showResolute(){
            this.showResolutionBox = !this.showResolutionBox
        },
    }
}
</script>
<style lang="less" scoped>
@import './style/common.less';
.cus-answer{
    margin: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionFillBlankView.vue